/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-alert */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import color from '../../../constants/color';
import materialUI from '../../../material-UI';
// import materialUI from '../../../material-UI';

import {
  Chip,
  MenuItem,
  Input,
} from './styles';

const useStyles = materialUI.makeStyles({
  root: {
    '& fieldset': {
      borderRadius: 40,
    },
  },
  input: {
    color: color.grey9,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
});

interface Props {
  value: any;
  onChange: any;
  data: Array<any>;
  isMultiple: boolean;
  label?: string;
  updateValue?: Function;
}

const SelectComponent: React.FC<Props> = ({
  data,
  onChange,
  value,
  isMultiple,
  label,
  updateValue,
}) => {
  const change = (event: any) => {
    event.preventDefault();
    // const uniqueUser = event.target.value.reduce((unique: any[], o: { value: any; }) => {
    //   if (
    //     !unique.some((obj: { value: any; }) => obj.value === o.value)
    //   ) {
    //     unique.push(o);
    //   }
    //   return unique;
    // }, []);
    // event.target.value = uniqueUser;
    onChange(event);
  };

  const handleDelete = (id: string, event: any) => {
    event.preventDefault();
    const newValue = {
      selecteds: value.filter((item: { value: string, label: string }) => item.value !== id),
    };
    if (updateValue) {
      updateValue(newValue);
    }
  };

  return (
    <>
      <Input
        fullWidth
        classes={{ root: useStyles().root }}
        select
        value={value}
        variant="outlined"
        name="selecteds"
        id="selecteds"
        defaultValue={value}
        label={label}
        inputProps={{ className: useStyles().input }}
        SelectProps={{
          multiple: isMultiple,
          onChange: change,
          renderValue: (selecteds: any) => (
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {selecteds.map((item: any) => (
                <Chip
                  key={item.label}
                  label={item.label}
                  size="small"
                  style={{ margin: 2 }}
                  deleteIcon={(
                    <CancelIcon
                      onMouseDown={(event) => event.stopPropagation()}
                    />
                    )}
                  onDelete={(event) => handleDelete(item.value, event)}
                />
              ))}
            </div>
          ),
        }}
      >
        {data.map((item) => (
          isMultiple ? <MenuItem value={item}>{item.label}</MenuItem>
            : <MenuItem value={item.id || item.value || item.idPerfilAcesso}>{item.nome}</MenuItem>
        ))}
      </Input>
    </>
  );
};
export default SelectComponent;
